export default __webpack_public_path__ + "static/Shoppers-at-jb-banner-8748e9193515274446dc32a8ee650c1a.webp";